import * as yup from "yup";
import { ClientError } from "../../error";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
export class TelephoneNumber extends SingleValueObject {
    telephoneNumber1;
    telephoneNumber2;
    telephoneNumber3;
    constructor(args) {
        super(args);
        this.telephoneNumber1 = args.telephoneNumber1;
        this.telephoneNumber2 = args.telephoneNumber2;
        this.telephoneNumber3 = args.telephoneNumber3;
    }
    static fromOneLine(code) {
        const schema = TelephoneNumber.schema();
        try {
            schema.telephoneNumber.validateSync(code);
        }
        catch (e) {
            if (yup.ValidationError.isError(e)) {
                throw new ClientError.InvalidValueObject(e.message);
            }
            throw e;
        }
        const [telephoneNumber1, telephoneNumber2, telephoneNumber3] = code.split("-");
        return new TelephoneNumber({
            telephoneNumber1,
            telephoneNumber2,
            telephoneNumber3,
        });
    }
    validator(args) {
        return this.validate(args, TelephoneNumber.innerSchema);
    }
    equals(t) {
        return (this.telephoneNumber1 === t?.telephoneNumber1 &&
            this.telephoneNumber2 === t?.telephoneNumber2 &&
            this.telephoneNumber3 === t?.telephoneNumber3);
    }
    getValue() {
        return this.toString();
    }
    toString() {
        return `${this.telephoneNumber1}-${this.telephoneNumber2}-${this.telephoneNumber3}`;
    }
    static schema(required = true) {
        return Schema.required({
            telephoneNumber: yup
                .string()
                .matches(/^\d{2,5}-\d{1,4}-\d{3,4}$/)
                .max(13)
                .label("電話番号"),
        }, required);
    }
    static innerSchema(required = true) {
        return Schema.required({
            telephoneNumber1: yup
                .string()
                .required()
                .max(4)
                .matches(/[0-9]+/)
                .label("電話番号"),
            telephoneNumber2: yup
                .string()
                .required()
                .max(4)
                .matches(/[0-9]+/)
                .label("電話番号"),
            telephoneNumber3: yup
                .string()
                .required()
                .max(4)
                .matches(/[0-9]+/)
                .label("電話番号"),
        }, required);
    }
}
//# sourceMappingURL=telephone-number.js.map